(function ($) {
  "use strict"; // Start of use strict

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
    if ($(window).width() > 768) {
      var e0 = e.originalEvent,
        delta = e0.wheelDelta || -e0.detail;
      this.scrollTop += (delta < 0 ? 1 : -1) * 30;
      e.preventDefault();
    }
  });

  // Scroll to top button appear
  $(document).on('scroll', function () {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $('.scroll-to-top').fadeIn();
    } else {
      $('.scroll-to-top').fadeOut();
    }
  });

  // Scroll to bottom button appear
  $(document).on('scroll', function () {
    var scrollDistance = $(this).scrollTop();
    var scrollBottom = $(window).scrollTop() + $(window).height();

    // console.log(scrollBottom);

    if (scrollDistance > 100) {
      $('.scroll-to-bottom').fadeIn();
    } else {
      $('.scroll-to-bottom').fadeOut();
    }
  });


  // Scroll to top
  $(document).on('click', 'a.scroll-to-top', function (e) {
    var $anchor = $(this);
    $('html, body').stop().animate({
      scrollTop: ($($anchor.attr('href')).offset().top)
    }, 1000, ''); //easeInOutExpo
    e.preventDefault();
  });

  // // Scroll to bottom
  // $(document).on('click', 'a.scroll-to-bottom', function (e) {
  //   var $anchor = $(this);
  //   $('html, body').stop().animate({
  //     scrollTop: ($($anchor.attr('href')).offset().top)
  //   }, 1000, ''); //easeInOutExpo
  //   e.preventDefault();
  // });


  // Fixed nav on mobile only
  // function stickyHeader() {
  //     var headerHeight = $('#header').outerHeight(true);
  //     if ($(document).width() < 576) {
  //         $('#header').addClass('fixed-top');
  //         $('#content').css('paddingTop',headerHeight);
  //       } else {
  //         $('#header').removeClass('fixed-top');
  //         $('#content').css('paddingTop',0);
  //     }
  // }

  function stickyHeader() {
    var headerHeight = $('#header').outerHeight(true);
    $('#header').addClass('fixed-top');
    $('#content').css('paddingTop', headerHeight);
  }

  stickyHeader();
  $(window).on('resize', function () {
    stickyHeader();
  });

  // Initiate AOS
  AOS.init();


  // Select2 - generic ones
  $('.select2').select2({
    placeholder: function () {
      $(this).data('placeholder');
      $(this + " .select2-search__field").css('width', '100%');
    }
  });

  $(".select2.nosearch").select2({
    minimumResultsForSearch: Infinity,
    placeholder: function () {
      $(this).data('placeholder');
      $(this + " .select2-search__field").css('width', '100%');
    }
  });

  $(".select2.multiple").select2({
    tokenSeparators: [','],
    placeholder: function () {
      $(this).data('placeholder');
      $(this + " .select2-search__field").css('width', '100%');
    }
  });

  $(".select2.multiple-with-add").select2({
    tags: true,
    tokenSeparators: [','],
    placeholder: function () {
      $(this).data('placeholder');
      $(this + " .select2-search__field").css('width', '100%');
    }
  });



  // Initiate datetime picker
  $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    icons: {
      time: 'far fa-clock',
      date: 'fas fa-calendar',
      up: 'far fa-arrow-up',
      down: 'far fa-arrow-down',
      previous: 'far fa-chevron-left',
      next: 'far fa-chevron-right',
      today: 'far fa-calendar-check-o',
      clear: 'far fa-trash',
      close: 'far fa-times'
    },
    format: 'YYYY/MM/DD', //added default format
    //debug: true
  });

  $('.date .input-group-append').datetimepicker().on('dp.show', function () {
    $(this).closest('.table-responsive').removeClass('table-responsive').addClass('temp');
  }).on('dp.hide', function () {
    $(this).closest('.temp').addClass('table-responsive').removeClass('temp')
  });

  //MODALS
  //??


  // Initiate dataTables
  $('.dataTable').DataTable({
    order: [],
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
    pageLength: 25,
    responsive: true
  });



  // TOP BAR HIGHLIGHT FOR MY JBs SITE - .active just need
  var currentpage = location.pathname;
  if (currentpage != '/') {
    $('.topnavbar .nav-item a.nav-link[href^="' + currentpage.split("/")[1] + '"]').addClass('active');
  }

  //TOOLTIPS
  //$('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="tooltip"]').tooltip({ container: 'body' });


  //LINK TO TAB
  var url = document.location.toString();
  if (url.match('#')) {
    $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
  }

  // Change hash for page-reload
  $('.nav-tabs a').on('shown.bs.tab', function (e) {
    window.location.hash = e.target.hash;
  })

  // Smooth scrolling scroll-link
  $(document).on('click', 'a.scroll-link', function (e) {
    var $anchor = $(this);
    var headerHeight = $('#header').outerHeight(true);
    $('html, body').stop().animate({
      scrollTop: ($($anchor.attr('href')).offset().top - headerHeight)
    }, 1000);
    e.preventDefault();
  });


})(jQuery); // End of use strict
